import { HttpContext, HttpContextToken } from "@angular/common/http";

/**
 * Quand ce jeton est positionné à true sur le contexte d'une requête HTTP,
 * l'intercepteur n'affiche PAS de toast d'erreur (utile pour des appels
 * « best-effort » comme le chargement optionnel de listes pour des menus,
 * où un 403 ne doit pas perturber l'utilisateur).
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/** Raccourci pour construire un HttpContext qui désactive le toast d'erreur. */
export function skipErrorToastContext(): HttpContext {
  return new HttpContext().set(SKIP_ERROR_TOAST, true);
}
